import { render, staticRenderFns } from "./import-case.vue?vue&type=template&id=97bc18a6&scoped=true"
import script from "./import-case.vue?vue&type=script&lang=ts"
export * from "./import-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bc18a6",
  null
  
)

export default component.exports